import http from './http'

const departamentosService = {
  getAll: page => http.get(`/departamentos?page=${page}`).then(result => result.data),
  getById: id => http.get(`/departamento/${id}`).then(result => result.data.data),
  getByAll: () => http.get(`/departamentosall`).then(result => result.data),
  delete: id => http.delete(`/departamentodelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/departamento`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/departamento/${data.id}`,
    data
  }).then(result => result.data.data)
}

export default departamentosService
